/* global File, HTMLIFrameElement, ProgressEvent */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import Promise from "bluebird";
import omit from "lodash/omit";
var uuid = function(a) {
    return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([
        1e7
    ] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
};
var defaultOptions = {
    type: "frontend",
    scope: {}
};
var APISession = /*#__PURE__*/ function() {
    "use strict";
    function APISession() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            type: "frontend"
        }, bridge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        _classCallCheck(this, APISession);
        this._uuid = uuid();
        this._options = _objectSpread({}, defaultOptions, options);
        this._listeners = [];
        this._bridge = bridge;
    }
    var _proto = APISession.prototype;
    _proto.cleanup = function cleanup() {
        this._listeners = [];
    };
    // EVENT API
    _proto.fire = function fire(eventName, payload) {
        var scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (eventName === "cbook" || this._options.scope && scope.chartId === this._options.scope.chartId) {
            this._listeners.forEach(function(l) {
                return l.eventName === eventName && l.callback(payload);
            });
        }
        return this;
    };
    _proto._isAlreadyBound = function _isAlreadyBound(eventName, callback) {
        return !!this._listeners.find(function(l) {
            return l.eventName === eventName && callback === l.callback;
        });
    };
    _proto.on = function on(eventName, callback) {
        if (this._isAlreadyBound(eventName, callback)) {
            console.warn("ExtensionAPISession: Listener (".concat(eventName, ") already bound to this Function"));
        } else {
            this._listeners.push({
                eventName: eventName,
                callback: callback
            });
            if (eventName !== "error") {
                this._requestEventData(eventName);
            }
        }
        return this;
    };
    _proto.off = function off(eventName, callback) {
        var listener = this._listeners.find(function(l) {
            return l.eventName === eventName && callback === l.callback;
        });
        if (listener) {
            var index = this._listeners.indexOf(listener);
            this._listeners.splice(index, 1);
        } else {
            console.error("Could not find Event Listener for '".concat(eventName, "' to unregister"));
        }
        return this;
    };
    _proto.cleanupListeners = function cleanupListeners() {
        this._listeners = [];
        return this;
    };
    _proto._requestEventData = function _requestEventData(eventName) {
        var _this = this;
        if (this._bridge && this._bridge.getCurrentData) {
            this._bridge.getCurrentData(this._options.scope, eventName).then(function(payload) {
                return _this.fire(eventName, payload, _this._options.scope);
            });
        } else {
            console.error("getCurrentData is not defined in the bridge");
        }
    };
    // REACTIVE API
    _proto._isBackend = function _isBackend() {
        return this._options.type === "backend";
    };
    _proto._isFrontend = function _isFrontend() {
        return this._options.type === "frontend";
    };
    _proto._isEvaluation = function _isEvaluation() {
        return this._options.type === "evaluation";
    };
    _proto._isFuncAvailable = function _isFuncAvailable(funcName) {
        return !!this._bridge[funcName];
    };
    _proto._callBridgeFunction = function _callBridgeFunction(name) {
        var check = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        for(var _len = arguments.length, data = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            data[_key - 2] = arguments[_key];
        }
        try {
            var _this__bridge;
            var scope = _objectSpread({}, this._options.scope);
            if (typeof scope.frame === "function") {
                scope.frame = scope.frame();
            }
            return check && this._isFuncAvailable(name) ? (_this__bridge = this._bridge)[name].apply(_this__bridge, [
                scope
            ].concat(_toConsumableArray(data))) : Promise.reject(new Error('Function "'.concat(name, '" not available')));
        } catch (error) {
            return Promise.reject(error);
        }
    };
    _proto.setChartData = function setChartData(data) {
        return this._callBridgeFunction("setChartData", this._isBackend(), typeof data === "string" ? data : JSON.stringify(data));
    };
    _proto.getUserData = function getUserData() {
        var _this = this;
        return this._callBridgeFunction("getUserData", this._isFrontend()).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.setUserData = function setUserData(data) {
        var _this = this;
        return this._callBridgeFunction("setUserData", this._isFrontend(), data).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.getUserProfile = function getUserProfile() {
        var _this = this;
        return this._callBridgeFunction("getUserProfile", this._isFrontend()).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.setUserProfile = function setUserProfile(data) {
        return this._callBridgeFunction("setUserProfile", this._isFrontend(), data);
    };
    _proto.getCommunityData = function getCommunityData() {
        var _this = this;
        return this._callBridgeFunction("getCommunityData", this._isFrontend()).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.getCommunityEvaluation = function getCommunityEvaluation() {
        var _this = this;
        return this._callBridgeFunction("getCommunityEvaluation", this._isEvaluation()).then(function(data) {
            return data.map(function(_d) {
                return {
                    meta: omit(_d, [
                        "data",
                        "id",
                        "node_id"
                    ]),
                    data: _d.data
                };
            });
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.getClaims = function getClaims() {
        return this._callBridgeFunction("getClaims");
    };
    _proto.claim = function claim(type) {
        return this._callBridgeFunction("claim", this._isBackend(), type);
    };
    _proto.releaseClaim = function releaseClaim(id) {
        return this._callBridgeFunction("releaseClaim", this._isBackend(), id);
    };
    _proto.resolveClaim = function resolveClaim(id) {
        return this._callBridgeFunction("resolveClaim", true, id);
    };
    _proto.getValueFromKey = function getValueFromKey(key) {
        return this._callBridgeFunction("getValueFromKey", true, key);
    };
    _proto.setKeyValue = function setKeyValue(key, value) {
        return this._callBridgeFunction("setKeyValue", true, key, value);
    };
    _proto.deleteKey = function deleteKey(key) {
        return this._callBridgeFunction("deleteKey", true, key);
    };
    _proto.jumpToChart = function jumpToChart(id) {
        this._callBridgeFunction("jumpToChart", this._isFrontend(), id);
    };
    _proto.sendNotification = function sendNotification(notification) {
        this._callBridgeFunction("sendNotification", this._isFrontend(), notification);
    };
    _proto.readyToPrint = function readyToPrint() {
        this._callBridgeFunction("readyToPrint", this._isFrontend());
    };
    _proto.includeThemeCSS = function includeThemeCSS() {
        this._callBridgeFunction("includeThemeCSS", true);
    };
    _proto.getThemeCSS = function getThemeCSS() {
        this._callBridgeFunction("getThemeCSS", true);
    };
    _proto.completeChart = function completeChart() {
        this._callBridgeFunction("completeChart", this._isFrontend());
    };
    /* -- Gallery // File Share -- */ _proto.getFiles = function getFiles() {
        var _this = this;
        return this._callBridgeFunction("getFiles", this._isFrontend()).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.getCommunityFiles = function getCommunityFiles() {
        var _this = this;
        return this._callBridgeFunction("getCommunityFiles", this._isFrontend()).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.updateFile = function updateFile(items, onProgress) {
        var _this = this;
        if (!Array.isArray(items) && items.id) {
            items = [
                items
            ];
        }
        return this._callBridgeFunction("updateFile", this._isFrontend(), items, onProgress).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.uploadFile = function uploadFile(files, onProgress) {
        var _this = this;
        if (!Array.isArray(files) && files.file) {
            files = [
                files
            ];
        }
        return this._callBridgeFunction("uploadFile", this._isFrontend(), files, onProgress).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _proto.removeFile = function removeFile(ids) {
        var _this = this;
        if (!Array.isArray(ids) && !isNaN(ids)) {
            ids = [
                ids
            ];
        }
        return this._callBridgeFunction("removeFile", this._isFrontend(), ids).then(function(data) {
            return data;
        }, function(error) {
            return _this.fire("error", error, _this._options.scope);
        });
    };
    _createClass(APISession, [
        {
            key: "id",
            get: function get() {
                return this._uuid;
            }
        },
        {
            key: "frame",
            get: function get() {
                return this._options.scope && this._options.scope.frame;
            }
        }
    ]);
    return APISession;
}();
export { APISession as default };
